import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetcher = (url) => api.get(url).then((r) => r.data);

export const fmtEth = (v, d = 6) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString("en-US", { maximumFractionDigits: d });

export const fmtUsd = (v) =>
  v === null || v === undefined ? "" : `$${Number(v).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "—");
